import React from "react";
import { EdButtonIcon } from "@frameworks/web/components/generic/edbutton/edButton";
import { maxPlaceOrderItems, } from "@frameworks/salesjourney/components/Features/PlaceOrder/MutualFund/MFPlaceOrderTable";
/**
 * MFPlaceOrderActionColumn
 *
 * This component is used on Place order screen to display Action items column
 *
 * @param {string} transactionId - specific row's unique Id
 * @param {any} schemeDetails - scheme details
 * @param {any} clientDetails - client details
 * @param {any} placeOrderData - place order screen details
 * @param {Function} callbackDisplayConfirmationPopup - call back function to show or hide confirmation popup
 * @param {string[]} selectedOrders - Selected orders on the place order table
 * @returns {}
 */
var MFPlaceOrderActionColumn = function (props) {
    var _a, _b, _c, _d;
    return (React.createElement("div", { className: "d-flex flex-row actions-column align-items-center gap-2" },
        React.createElement(EdButtonIcon, { className: "bg-transparent hover-blue-icon", btnIcon: "edel-icon-editicon-underline DMSansNormal_20_400", btnTyp: "link", paths: 3, disabled: !(Boolean(props.schemeDetails) && Boolean(props.clientDetails)) ||
                props.selectedOrders.length > 0, onClick: function () {
                return props.callbackEditOrderDetails(props.schemeDetails, props.clientDetails, props.placeOrderId);
            } }),
        React.createElement(EdButtonIcon, { className: "bg-transparent hover-blue-icon", btnIcon: "edel-icon-page-copy DMSansNormal_20_400", btnTyp: "link", paths: 3, disabled: !Boolean(props.schemeDetails) ||
                props.placeOrderData.length === maxPlaceOrderItems ||
                props.selectedOrders.length > 0, onClick: function () {
                return props.callbackDisplayConfirmationPopup("duplicateOrders" /* EPlaceOrderActions.DUPLICATE_ORDERS */, [props.placeOrderId]);
            } }),
        React.createElement("div", { className: "vl" }),
        React.createElement(EdButtonIcon, { className: "bg-transparent delete-icon", btnIcon: "edel-icon-delete-red1 DMSansNormal_20_400", btnTyp: "link", disabled: props.selectedOrders.length > 0 ||
                (props.placeOrderData.length === 1 &&
                    !((_b = (_a = props.placeOrderData) === null || _a === void 0 ? void 0 : _a[0].scheme) === null || _b === void 0 ? void 0 : _b.schemeName) &&
                    !((_d = (_c = props.placeOrderData) === null || _c === void 0 ? void 0 : _c[0].clientDetails) === null || _d === void 0 ? void 0 : _d.clientName)), onClick: function () {
                return props.callbackDisplayConfirmationPopup("deleteOrders" /* EPlaceOrderActions.DELETE_ORDERS */, [props.placeOrderId]);
            } })));
};
export default MFPlaceOrderActionColumn;
